import { CustomColorInput } from "./CustomColorInput";

export default CustomColorInput;
